'use client';
import { useRef } from 'react';
import { useLead } from '@witmetrics/data-store';
import { isEmpty } from '@witmetrics/utils/misc';
import { formatUserName } from '@witmetrics/utils/strings';
import { usePath } from '@/hooks/usePath';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { getCrmUrl } from '@/api/urls';
import Card from '@/components/Card';
import Note from '@/components/Note';
import { CloseIcon, OptionsIcon } from '@/icons';
import DefaultOptionsMenu from '@/components/DefaultOptionsMenu';
import IconButton from '@/components/IconButton';
import Button from '@/components/Button';
import ProfilePicture from '@/components/ProfilePicture';
import EditPatientDialog from '@/dialogs/EditPatientDialog';
// import DeleteProjectDialog from '@/dialogs/DeleteProjectDialog';
import { classes } from './utils';

export default function PatientHeader() {
  const menuToggleRef = useRef(null);
  const { activeLeadId, onClearActiveLead } = useAppState();
  const { navigate } = usePath();
  const lead = useLead(activeLeadId);
  const [isEditing, toggleEditing] = useToggle();
  const [isDeleting, toggleDeleting] = useToggle();
  const [isMenuOpen, toggleMenu] = useToggle();

  const handleGoToCRM = () => {
    return navigate(`${getCrmUrl()}/dashboard/overview`, {
      activeLeadId,
    });
  };

  const handleEdit = () => {
    toggleMenu(false);
    toggleEditing(true);
  };

  const handleDelete = () => {
    toggleMenu(false);
    toggleDeleting(true);
  };

  if (!lead) return null;

  return (
    <>
      {isEditing && (
        <EditPatientDialog
          patientId={activeLeadId!}
          onClose={() => toggleEditing(false)}
        />
      )}
      {/*{isDeleting && (*/}
      {/*  <DeleteProjectDialog*/}
      {/*    projectId={activeProjectId!}*/}
      {/*    onDelete={onClearActiveProject}*/}
      {/*    onClose={() => toggleDeleting(false)}*/}
      {/*  />*/}
      {/*)}*/}
      <Card className={classes.card}>
        <div className={classes.infoWrapper}>
          <ProfilePicture size={60} user={lead} />
          <div>
            <div className={classes.nameWrapper}>
              <h1 className={classes.name}>{formatUserName(lead)}</h1>
              <Button
                className={classes.leadButton}
                variant="secondary"
                onClick={handleGoToCRM}>
                Open in CRM
              </Button>
            </div>
            {!isEmpty(lead.externalRef) && (
              <Note className={classes.description} value={lead.externalRef!} />
            )}
          </div>
        </div>
        <div className={classes.controls}>
          <IconButton
            ref={menuToggleRef}
            aria-label="options"
            onClick={() => toggleMenu()}>
            <OptionsIcon className={classes.optionsIcon} />
          </IconButton>
          <DefaultOptionsMenu
            anchorTo={menuToggleRef.current}
            open={isMenuOpen}
            onEdit={handleEdit}
            onDelete={handleDelete}
            onClose={() => toggleMenu(false)}
          />
          <IconButton aria-label="close" onClick={onClearActiveLead}>
            <CloseIcon className={classes.closeIcon} />
          </IconButton>
        </div>
      </Card>
    </>
  );
}
